<div *ngIf="title || description || effectiveMetrics"
  class="flex flex-col gap-4 w-full border-b border-foreground/[0.03] pb-3 px-1 animate-fade-in">
  <div class="flex flex-wrap items-center justify-between gap-4">
    <div class="flex items-center gap-3 min-w-0">


      <!-- Main Icon -->
      <div *ngIf="icon"
        class="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0 transition-all border border-primary/20 shadow-sm">
        <iconify-icon [attr.icon]="icon" class="text-xl md:text-2xl text-blue-600 dark:text-blue-400"></iconify-icon>
      </div>

      <!-- Title and Description -->
      <div class="flex flex-col justify-center gap-0.5 min-w-0">
        <h2 *ngIf="title"
          class="text-sm md:text-base font-bold text-foreground/90 dark:text-white leading-tight uppercase tracking-wide whitespace-nowrap overflow-hidden text-ellipsis">
          {{ title }}
        </h2>
        <p *ngIf="description"
          class="text-[9px] md:text-[10px] text-foreground/75 font-bold leading-tight line-clamp-2 max-w-[200px] md:max-w-[400px]">
          {{ description }}
        </p>
      </div>
    </div>

    <!-- Metrics Area (Optional Slot) -->
    <div *ngIf="effectiveMetrics" class="flex items-center gap-2 flex-shrink-0 ml-auto">
      <ng-container [ngTemplateOutlet]="effectiveMetrics"></ng-container>
    </div>
    <!-- Back Button -->

    <app-button *ngIf="showBack" variant="glass" size="xs" (click)="goBack()" iconLeft="solar:arrow-left-bold-duotone"
      class="h-7 text-[8px] px-3 font-bold uppercase shrink-0 mb-1">
      Volver
    </app-button>
  </div>

  <!-- Extra Header Area (e.g. for metrics under title) -->
  <div *ngIf="effectiveExtra" class="animate-fade-in">
    <ng-container [ngTemplateOutlet]="effectiveExtra"></ng-container>
  </div>
</div>